import React, { useState } from 'react';
import { talks } from '../data/talks';
import { FileText, ExternalLink, Presentation } from 'lucide-react';
import './Talks.css';

const years = Object.keys(talks).sort((a, b) => b - a);

function Talks() {
  const [activeYear, setActiveYear] = useState(null);

  const displayYears = activeYear ? [activeYear] : years;
  const totalCount = years.reduce((s, y) => s + talks[y].length, 0);

  return (
    <div className="talks-page">
      <div className="container">
        <section className="page-hero">
          <h1>Talks</h1>
          <p className="subtitle">
            Recent talks, presentations, and posters by our group members at
            international conferences and seminars.
          </p>
        </section>

        {/* Stats and filters */}
        <div className="talks-toolbar">
          <div className="talks-stats">
            <Presentation size={16} />
            <span>{totalCount} presentations across {years.length} years</span>
          </div>
          <div className="year-pills">
            <button
              className={`year-pill ${activeYear === null ? 'active' : ''}`}
              onClick={() => setActiveYear(null)}
            >
              All
            </button>
            {years.map(y => (
              <button
                key={y}
                className={`year-pill ${activeYear === y ? 'active' : ''}`}
                onClick={() => setActiveYear(activeYear === y ? null : y)}
              >
                {y} ({talks[y].length})
              </button>
            ))}
          </div>
        </div>

        {/* Talks list */}
        <div className="talks-list">
          {displayYears.map(year => (
            <div className="talks-year-group" key={year}>
              <h2 className="talks-year-label">{year}</h2>
              <div className="talks-items">
                {talks[year].map((talk, i) => (
                  <div className="talk-item" key={i}>
                    <div className="talk-content">
                      <h3 className="talk-title">
                        {talk.pdf ? (
                          <a href={talk.pdf} target="_blank" rel="noopener noreferrer">
                            {talk.title}
                          </a>
                        ) : talk.link ? (
                          <a href={talk.link} target="_blank" rel="noopener noreferrer">
                            {talk.title}
                          </a>
                        ) : (
                          talk.title
                        )}
                      </h3>
                      <div className="talk-meta">
                        <span className="talk-speaker">{talk.speaker}</span>
                        <span className="talk-venue">{talk.venue}</span>
                      </div>
                    </div>
                    <div className="talk-badges">
                      {talk.poster && <span className="tag">Poster</span>}
                      {talk.pdf && (
                        <a href={talk.pdf} className="pub-link" target="_blank" rel="noopener noreferrer">
                          <FileText size={13} /> PDF
                        </a>
                      )}
                      {talk.link && (
                        <a href={talk.link} className="pub-link" target="_blank" rel="noopener noreferrer">
                          <ExternalLink size={13} /> Link
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Talks;
